import { url } from "../Common/common";


// Универсальная функция для POST-запросов
async function postFormData(endpoint, pars) {
  const formData = new FormData();
  Object.entries(pars).forEach(([key, value]) => {
    formData.append(key, value);
  });

  try {
    const response = await fetch(`${url}${endpoint}`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Ошибка сервера: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Ошибка при запросе:", error);
    return { res: false, message: error.message };
  }
}

// Авторизация
export async function doLogin(pars) {
  const loginParams = {
    email: pars.email,
    password: pars.password,
  };
  
  // Добавляем referrer_id, если он передан
  if (pars.referrer_id) {
    loginParams.referrer_id = pars.referrer_id;
  }
  
  return await postFormData("/login", loginParams);
}

// Восстановление пароля
export async function doForgetPassword(pars) {
  return await postFormData("/forgetpassword", {
    email: pars.email,
  });
}

// Сохранение настроек
export async function sendSettings(pars) {
  return await postFormData("/setsettings", {
    user_id: pars.user_id,
    company_name: pars.company_name,
    language: pars.language,
    bank_name: pars.bank_name,
    bik: pars.bik,
    checking_account: pars.checking_account,
    correspondent_account: pars.correspondent_account,
    inn: pars.inn,
    kpp: pars.kpp,
  });
}

// Добавление токена (например, пуш-токен)
export async function addToken(pars) {
  return await postFormData("/addtoken", {
    token: pars.token,
    v: pars.v,
  });
}
